// eslint-disable-next-line
import React from "react";
import { useSelector } from "react-redux";
import { Link, Outlet } from "react-router-dom";

const AdminPanel = () => {
  const user = useSelector((state) => state.user?.user?.user);

  // console.log("user", user);



  return (
    <div className="flex ">
      <aside
        className=" hidden md:block  w-[70%] min-w-[20%] bg-white h-[calc(100vh-101px)] max-h-[calc(100vh-101px)]  shadow-sm"
        style={{ borderTop: "1px solid #e0e0e0" }}
      >
        <div className="flex flex-col items-center justify-center h-[100px] ">
          <h1 className="username capitalize">
            {" "}
            <Link to={"/user-profile"}>{user?.username || "Admin"}</Link>{" "}
          </h1>
        </div>

        <div className="text-right">
          <nav className="flex items-start flex-col justify-start gap-[5px]">
            <ul className="flex gap-[10px] whitespace-nowrap flex-col text-[18px] transition-all text-left px-[20px] w-[100%] ">
              <li className="cursor-pointer  py-2 w-[100%]  hover:bg-slate-100 text-start ">
                <Link to="all-users">All Users</Link>
              </li>
              <hr className="hidden md:block w-[80%]  bg-main-background h-[2px]" />
              <hr className="block md:hidden w-[80%]  bg-main-background h-[1px]" />
              <li className="cursor-pointer w-[100%]  py-2 hover:bg-slate-100 text-start">
                <Link to="all-products">All Products</Link>
              </li>
              <hr className="hidden md:block w-[80%]  bg-main-background h-[2px]" />
              <hr className="block md:hidden w-[80%]  bg-main-background h-[1px]" />
              <li className="cursor-pointer  py-2 w-[100%]  hover:bg-slate-100 text-start ">
                <Link to="all-orders">All Orders</Link>
              </li>
              
            </ul>
          </nav>
        </div>
      </aside>

      <menu className="w-[100%] min-w-[80%] md:h-[auto] md:overflow-scroll md:overflow-x-hidden md:scroll-none scroll-smooth screen-touch">
        <Outlet />
      </menu>
    </div>
  );
};

export default AdminPanel;
